<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card class="px-4 py-4">
      <v-card-title>
        Resultado da importação
      </v-card-title>
      <v-progress-linear
        v-if="loading"
        color="amber"
        indeterminate
      />
      <v-card-text>
        <span v-if="result.errors" class="red--text">
          <p
            v-for="(err, index) in result.errors"
            :key="index"
          >
            linha {{ err.row }} - {{ err.reason }}
          </p>
          {{ result.error }}
        </span>
        {{ result.imported }} resultados importados com sucesso.
        <br/>
        {{ result.skipped_existing }} resultados já existentes foram ignorados.
      </v-card-text>
      <div class="d-flex justify-space-center">
        <v-btn
          color="primary"
          text
          @click="onCancel"
        >
          fechar
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import handlesServerValidation from '@/mixins/handles-server-validation.js'

export default {
  mixins: [
    handlesServerValidation
  ],

  props: {
    result: { type: Object, default: null }
  },

  data: () => ({
    errors: null,
    imported: null,
    skipped_existing: null,
    loading: false
  }),
  computed: {
  },
  async mounted () {
  },

  methods: {
    onCancel () {
      this.$emit('resolve', false)
    }
  }
}
</script>
